import {
  Box,
  chakra,
  Container,
  Stack,
  Text,
  useColorModeValue,
  VisuallyHidden,
} from "@chakra-ui/react";
import { FaTelegram, FaTwitter, FaMedium } from "react-icons/fa";
import { ReactNode } from "react";

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode,
  label: string,
  href: string,
}) => {
  return (
    <chakra.button
      bg={useColorModeValue("blackAlpha.100", "whiteAlpha.100")}
      rounded={"full"}
      w={8}
      h={8}
      cursor={"pointer"}
      as={"a"}
      href={href}
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: useColorModeValue("blackAlpha.200", "whiteAlpha.200"),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

export default function Footer() {
  return (
    <Box mt={{ base: "60px", md: "0px" }} bg="blue.500" color="white">
      <Container
        as={Stack}
        maxW={"6xl"}
        py={4}
        direction={{ base: "column", md: "row" }}
        spacing={4}
        justify={{ base: "center", md: "space-between" }}
        align={{ base: "center", md: "center" }}
      >
        <Text>© 2024 GhostSwap AI. All rights reserved</Text>
        <Stack direction={"row"} spacing={6}>
          <SocialButton
            label={"Twitter"}
            href={"https://twitter.com/ghostswaponbase"}
          >
            <FaTwitter />
          </SocialButton>
          <SocialButton
            label={"Telegram"}
            href={"https://t.me/ghostswapofficial"}
          >
            <FaTelegram />
          </SocialButton>
          {/*  <SocialButton
            label={"Medium"}
            href={
              "https://medium.com/@sukiyaki.sukiyaki2000/famous-chef-sukiyaki-cooks-first-ai-powered-dex-37cf472fca89"
            }
          >
            <FaMedium />
          </SocialButton> */}
        </Stack>
      </Container>
    </Box>
  );
}
